/** Socket messages class */
function SocketMessages() {}
/** Notification msg */
SocketMessages.NOTIF_MSG = '001';
/** Navbar change */
SocketMessages.NAV_LIST_CHANGE = '002';
/** User switched to another team */
SocketMessages.USER_SWITCHED_TEAM = '003';
/** Content change messages */
SocketMessages.CC_MSGS = {};
SocketMessages.CC_MSGS.ACTION_PLANS = '010';
SocketMessages.CC_MSGS.PENDING = '011';
SocketMessages.CC_MSGS.PROBLEMS = '012';
SocketMessages.CC_MSGS.INDICATORS = '013';
SocketMessages.CC_MSGS.PENDING_AND_PLANS = '014';
SocketMessages.CC_MSGS.PROBLEMS_AND_PLANS = '015';
SocketMessages.CC_MSGS.PENDING_AND_PROBLEMS = '016';
SocketMessages.CC_MSGS.MEETING_RATING = '017';
SocketMessages.CC_MSGS.MEETING_ROLES = '018';
SocketMessages.CC_MSGS.MEETING_INFOS = '019';
SocketMessages.CC_MSGS.PROBLEM_SHEET = '020';
SocketMessages.CC_MSGS.GW_STEP = '021';
SocketMessages.CC_MSGS.GW_END = '022';
SocketMessages.CC_MSGS.PROBLEM_COMMENTS = '023';
SocketMessages.CC_MSGS.STICKERS = '024';
SocketMessages.CC_MSGS.ACTION_EDITION = '026';
SocketMessages.CC_MSGS.GW_RATING = '027';
SocketMessages.CC_MSGS.PROBLEM_ACCESS = '028';
SocketMessages.CC_MSGS.PUBLIC_INDICATOR = '029';
SocketMessages.CC_MSGS.PROBLEM_LINKS = '030';
SocketMessages.CC_MSGS.CFG_PAGE_STICKERS = '031';
SocketMessages.CC_MSGS.CFG_PAGE = '032';
SocketMessages.CC_MSGS.WIDGET = '033';
SocketMessages.CC_MSGS.GW_CANCELLED = '034';
SocketMessages.CC_MSGS.VH_GROUPS = '035';
SocketMessages.CC_MSGS.TEXT_PER_DATE_WIDGET = '036';
SocketMessages.CC_MSGS.PENDING_ACTIONS_NUMBER = '037';
SocketMessages.CC_MSGS.INFO_EDITION = '038';
SocketMessages.CC_MSGS.SYNC_USER_JOINED = '039';
SocketMessages.CC_MSGS.SYNC_USER_LEFT = '040';
/** Meeting messages */
SocketMessages.MT_MSGS = {};
SocketMessages.MT_MSGS.STARTED = '110';
SocketMessages.MT_MSGS.END = '111';
SocketMessages.MT_MSGS.STEP_CHANGE = '112';
SocketMessages.MT_MSGS.PAGE_CHANGE = '113';
SocketMessages.MT_MSGS.ROLES_UPDATE = '114';
/** Session stats messages */
SocketMessages.SESSION_MSGS = {};
SocketMessages.SESSION_MSGS.ACTIVITY = '0001';

export default SocketMessages;
